module.exports = __webpack_public_path__ + "static/media/Air Asia_6_Calendar.648416a3.jpg";